<svelte:options customElement="hb-sidebar-cards-navigator" />

<script lang="ts">
  import pkg from "../../../package.json";
  import { addComponent, LanguageTranslator } from "wc-js-utils";
  import type {
    Component,
    CardRowSelected,
    CardRow,
    Panel,
  } from "./types/webcomponent.type";
  import type {
    Component as SidenavButtonComponent,
    Events as SidenavButtonEvents,
  } from "../sidenav-button/types/webcomponent.type";
  import type { Events as NavbarEvents } from "../navbar/types/webcomponent.type";
  function dispatch(name: string, detail: any) {
    $host().dispatchEvent(new CustomEvent(name, { detail }));
  }

  let {
    id = "", // style,
    panels = [],
  }: Component = $props();

  // export let string: string;
  // export let json: Component["json"];
  // export let boolean: boolean;
  let switchToPanelId: string = $state("");
  let panel = $derived(
    switchToPanelId
      ? panels.find((p) => p.id === switchToPanelId)
      : panels?.find?.((f) => f.main) ||
          panels?.find?.((f) => !f.parentPanelId),
  );

  $effect(() => {
    if (!id) id = "";
    // if (style) {
    //     navbarStyleSetup?.vars,
    //   );
    //     sidenavButtonStyleSetup?.vars,
    //   );
    // }
    // if (!string) string = "";

    // panels
    if (typeof panels === "string") {
      try {
        panels = JSON.parse(panels);
      } catch (err) {
        console.error("error parsing panels", err);
      }
    }

    // // boolean
    // if (boolean === ("" as unknown)) boolean = true;
    // if (typeof boolean === "string") boolean = boolean === "no" || boolean === "false" ? false : true;
    // if (!boolean) boolean = false;
  });

  // onMount(() => {
  // 	console.log($host()?.shadowRoot?.querySelector("#skeletontest"));
  // });

  // function dispatchCustomEvent() {
  // 	dispatch("event", { test: true });
  // }
  function itemClick(itemId: string, cardId: string) {
    const card = panel?.cards.find((c) => c.id === cardId);
    const rowItem = card?.rows.find((r) => r.key === itemId);
    if (rowItem) {
      const simplePanel = Object.assign({}, panel);
      delete (simplePanel as { cards?: any }).cards;

      const simpleCard = Object.assign({}, card);
      delete (simplePanel as { rows?: any }).rows;

      const customCard: CardRowSelected = {
        id,
        row: rowItem,
        panel: simplePanel,
        card: simpleCard,
      };
      dispatch("itemClick", customCard);
      if (rowItem.switchToPanelId) {
        // const oldPanelId = panel.id;
        switchToPanelId = rowItem.switchToPanelId;
      }
    }
  }
  addComponent({ repoName: "@htmlbricks/hb-navbar", version: pkg.version });
  addComponent({
    repoName: "@htmlbricks/hb-sidenav-button",
    version: pkg.version,
  });

  function rowToLineNavlink(row: CardRow) {
    const newSidebarLink: SidenavButtonComponent["navlink"] = {
      text: row.text,
      key: row.key,
    };
    if (row.bootstrapIcon) newSidebarLink.bootstrapIcon = row.bootstrapIcon;
    if (row.badge) newSidebarLink.badge = row.badge;
    return newSidebarLink;
  }
</script>

<svelte:head>
  <link
    rel="stylesheet"
    href="https://cdn.jsdelivr.net/npm/bootstrap-icons@latest/font/bootstrap-icons.css"
  />
</svelte:head>
{#if panel}
  <div class="hb-sidebar-cards-stack">
    <hb-navbar
      onnavmenuswitch={(s: { detail: NavbarEvents["navmenuswitch"] }) => {
        if (panel?.parentPanelId) {
          switchToPanelId = panel?.parentPanelId;
        }
      }}
      companybrandname={panel.title}
    >
      <i
        slot="nav-switcher"
        class="bi bi-{panel.parentPanelId ? 'arrow-left' : 'list'} hb-sidebar-cards-nav-icon"
        class:hb-sidebar-cards-nav-icon--back={!!panel.parentPanelId}
      ></i>
    </hb-navbar>
    {#each panel.cards as card (card.id + "_c_" + panel.id)}
      {#if card.rows && card.rows.length > 0}
        <div class="is-flex is-flex-direction-column is-gap-1">
          {#each card.rows as row (row.key + "_r_" + card.id)}
            <hb-sidenav-button
              onpageChange={(e: {
                detail: SidenavButtonEvents["pageChange"];
              }) => {
                itemClick(row.key, card.id);
              }}
              navlink={JSON.stringify(rowToLineNavlink(row))}
            ></hb-sidenav-button>
          {/each}
        </div>
      {/if}
    {/each}
  </div>
{/if}
<style lang="scss">
  @forward "./styles/bulma.scss";
  @forward "./styles/webcomponent.scss";
</style>
